import { table } from './_table';
import { skills } from './_skills';
export const operators = {
  namespaced: true,
  modules: {
    table,
    skills
  }
};
